import * as React from "react";
import { SVGProps } from "react";

const InjectiveProtocol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 41 40"
    {...props}
  >
    <linearGradient
      id="a"
      x1={7.665}
      x2={22.644}
      y1={5.77}
      y2={31.717}
      gradientTransform="matrix(1 0 0 -1 0 42)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#174e5b" />
      <stop offset={0.07} stopColor="#195a6c" />
      <stop offset={0.21} stopColor="#1e779a" />
      <stop offset={0.4} stopColor="#27a7e3" />
      <stop offset={0.47} stopColor="#2abaff" />
      <stop offset={0.7} stopColor="#1ddaf0" />
      <stop offset={1} stopColor="#0effe0" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M25.9 38.9c-.1-.1-.2-.2-.3-.2-2.3-.5-4.6-1.3-6.6-2.5-4.2-2.5-7-6.2-7.1-10.5 0-1.6.3-3.2 1-4.7.4-1 2.8-4.4 3.1-5 1.6-2.5 1.1-2.3-1.2-5.4l-3.2-4.7-2.1-3.2C8.3 3.5 7.1 4.5 6 5.5c-2.2 2.2-3.9 5-4.9 8-1 3-1.3 6.2-.9 9.3s1.6 6.1 3.4 8.7c1.8 2.6 4.2 4.8 6.9 6.3-7.1-5.2-10.4-13.1-7.7-21 .7-2.1 1.8-4.1 3.2-5.9l2.3 3.4c.1.2.2.4.2.7 0 .2-.1.5-.2.7-1.1 1.4-2 2.9-2.6 4.6-3 8.7 5.1 17.7 13.6 19.2 1.6.3 4.6.6 6.2.2.1 0 .2-.1.2-.1.1-.1.1-.1.1-.2v-.3c.2 0 .2-.1.1-.2z"
    />
    <linearGradient
      id="b"
      x1={33.338}
      x2={18.358}
      y1={38.229}
      y2={12.285}
      gradientTransform="matrix(1 0 0 -1 0 42)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#174e5b" />
      <stop offset={0.07} stopColor="#195a6c" />
      <stop offset={0.21} stopColor="#1e779a" />
      <stop offset={0.4} stopColor="#27a7e3" />
      <stop offset={0.47} stopColor="#2abaff" />
      <stop offset={0.7} stopColor="#1ddaf0" />
      <stop offset={1} stopColor="#0effe0" />
    </linearGradient>
    <path
      fill="url(#b)"
      d="M15.1 1.1c.1.1.2.2.3.2 2.3.5 4.6 1.3 6.6 2.5 4.2 2.5 7 6.2 7.1 10.5 0 1.6-.3 3.2-1 4.7-.4 1-2.8 4.4-3.1 5-1.6 2.5-1.1 2.3 1.2 5.4l3.2 4.7 2.2 3.2c1.2-.8 2.4-1.8 3.5-2.8 2.2-2.2 3.9-5 4.9-8 1-3 1.3-6.2.9-9.3-.4-3.1-1.6-6.1-3.4-8.7s-4.2-4.8-6.9-6.3c7.1 5.2 10.4 13.1 7.6 21-.7 2.1-1.8 4.1-3.2 5.9l-2.3-3.4c-.1-.2-.2-.4-.2-.7 0-.2.1-.5.2-.7 1.1-1.4 2-2.9 2.6-4.6C38.3 11 30.2 2 21.7.5c-1.6-.3-4.6-.6-6.2-.2-.1 0-.2.1-.2.1-.2 0-.3.1-.3.2v.3s0 .1.1.2z"
    />
  </svg>
);

export default InjectiveProtocol;
